import type { CountryCode } from '../constants/countries';
import { COUNTRIES } from '../constants/countries';

interface Country {
  value: string;
  label: string;
}

/**
 * Use `getLocalizedCountryNameFromCode` if you want to get translated country name
 */
export const getCountryNameFromCode = (countryCode: CountryCode): string => {
  const country = COUNTRIES.find((c: Country) => c.value === countryCode);

  if (!country) {
    return 'unknown';
  }

  return country.label;
};
